var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 12L0 12L0 10.6667L0.666667 10.6667L0.666667 6.02067C0.666667 2.69533 3.35333 0 6.66667 0C9.98 0 12.6667 2.69533 12.6667 6.02067L12.6667 10.6667L13.3333 10.6667L13.3333 12ZM2 10.6667L11.3333 10.6667L11.3333 6.02067C11.3333 3.432 9.244 1.33333 6.66667 1.33333C4.08933 1.33333 2 3.432 2 6.02067L2 10.6667ZM5 12.6667L8.33333 12.6667C8.33333 13.1087 8.15774 13.5326 7.84518 13.8452C7.53262 14.1577 7.10869 14.3333 6.66667 14.3333C6.22464 14.3333 5.80072 14.1577 5.48816 13.8452C5.17559 13.5326 5 13.1087 5 12.6667L5 12.6667Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 1.33333 1.33333)",
    fill: "currentColor"
  })));
};
export default SvgNotification;